import SyncLoader from "react-spinners/SyncLoader";


class Loader {
    render(text: string, classNames: string = "") {
        let className = classNames ? "loading " + classNames : "loading"
        return (
            <div className={className}>
                {text && (
                    <div className="loading-message">{text}</div>
                )}
                <SyncLoader size="10" color="#5cd5eb"/>
            </div>
        )
    }
}

export default Loader
